import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

function RSVPModal({ isOpen, onClose, eventId, onRsvpSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    attendance: "",
    guest: "",
  });
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (isOpen) {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        try {
          const user = JSON.parse(savedUser);
          setFormData((prev) => ({
            ...prev,
            name: user.name || "",
            email: user.email || "",
          }));
        } catch {
          console.warn("Invalid user data in localStorage");
        }
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("authToken")

      const apiUrl = `${TEST_BASE_URL}/event-registration`;

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          attendance_status: formData.attendance,
          guest: formData.guest,
          event_id: eventId,
        }),
      });

      const text = await response.text();
      let data;

      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid JSON response from server");
      }

      if (response.status === 404) {
        toast.error("Event registration endpoint not found.");
        console.error("404: /event-registration does not exist.");
        return;
      }

      if (!response.ok) {
        toast.error(data.message || "Failed to send RSVP.");
        return;
      }

      toast.success(data.message || "RSVP sent successfully!");
      console.log("Registration successful!");
      console.log("Calling onRsvpSuccess callback");

      if (onRsvpSuccess) {
        onRsvpSuccess();
      }

      setFormData({
        name: "",
        email: "",
        attendance: "",
        guest: "",
      });

      setTimeout(onClose, 800);
    } catch (error) {
      console.error("RSVP submission error:", error);

      if (error.message.includes("Failed to fetch")) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rsvp-backdrop" role="dialog" aria-modal="true">
      <div className="rsvp-box">
        <h5>RSVP</h5>
        <h6>Worship Night: Sound of Heaven</h6>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Confirm name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your name"
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label>Confirm email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter email"
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label>Will you be attending?</label>
            {["yes", "no", "maybe"].map((option) => (
              <div className="attend-rsvp" key={option}>
                <input
                  type="radio"
                  name="attendance"
                  value={option}
                  checked={formData.attendance === option}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
                <div className="rsvp-dotted"></div>
                <span>
                  {option === "yes"
                    ? "Yes, I wouldn't miss it!"
                    : option === "no"
                    ? "No, I can't make it"
                    : "Maybe"}
                </span>
              </div>
            ))}
          </div>

          <div className="form-group">
            <label>Will you be bringing a guest?</label>
            {["yes", "no"].map((option) => (
              <div className="attend-rsvp" key={option}>
                <input
                  type="radio"
                  name="guest"
                  value={option}
                  checked={formData.guest === option}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
                <div className="rsvp-dotted"></div>
                <span>
                  {option === "yes" ? "Yes, I would" : "No, I wouldn't"}
                </span>
              </div>
            ))}
          </div>

          <p className="my-4" style={{ fontSize: "13px" }}>
            Please read our{" "}
            <a
              href="https://www.rccgbournemouth.org/privacy-notice"
              className="text-dark"
              target="_blank"
              rel="noopener noreferrer"
            >
              <u>Privacy Notice</u>
            </a>{" "}
            to learn how we protect your personal data.
          </p>

          <div className="rsvp-buttons">
            <button
              type="button"
              className="btn rsvp-cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn rsvp-now"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "RSVP Now"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RSVPModal;